// extracted by mini-css-extract-plugin
export default {"page":"styles_page__XKrI3","withFooter":"styles_withFooter__oHnnm"};